﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_customAdImageList from './tpl/customAdImageList.html';
import View_CustomAdImageListItem from './customAdImageListItem';

export default Marionette.CollectionView.extend({
    tagName: 'customAdImageList',
    childViewContainer: '#customAdImageList',
    childView: View_CustomAdImageListItem,
    getTemplate: function () {
        return tpl_customAdImageList();
    },
    initialize: function () {
        this.app = this.options.app;
    },
    buildChildView: function(child, ChildViewClass, childViewOptions){
        var options = _.extend({model: child}, childViewOptions);
        options.app = this.app;
        var view = new ChildViewClass(options);
        return view;
    }
});
